import { adminClient, jwtClient } from 'better-auth/client/plugins'
import { createAuthClient } from 'better-auth/react'

// Better Auth 服务端 URL
let API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:9999'

if (typeof window !== 'undefined') {
  const hostname = window.location.hostname
  if (hostname === 'tabetabi.cc' || hostname === 'www.tabetabi.cc') {
    if (API_BASE_URL.includes('localhost') || API_BASE_URL.includes('workers.dev')) {
      API_BASE_URL = 'https://api.tabetabi.cc'
    }
  }
}

export let BETTER_AUTH_URL = import.meta.env.VITE_BETTER_AUTH_URL || `${API_BASE_URL}/api/auth`
if (typeof window !== 'undefined') {
  const hostname = window.location.hostname
  if (hostname === 'tabetabi.cc' || hostname === 'www.tabetabi.cc') {
    if (BETTER_AUTH_URL.includes('localhost') || BETTER_AUTH_URL.includes('workers.dev')) {
      BETTER_AUTH_URL = 'https://api.tabetabi.cc/api/auth'
    }
  }
}

export const authClient = createAuthClient({
  baseURL: BETTER_AUTH_URL,
  plugins: [
    adminClient(),
    jwtClient(),
  ],
  fetchOptions: {
    onRequest: (ctx) => {
      // Normalize callbackURL to absolute URL on the frontend origin
      const normalizeCallbackURL = (url: string | undefined | null): string => {
        if (!url) {
          const origin = typeof window !== 'undefined' ? window.location.origin : (import.meta.env.VITE_APP_URL || 'https://tabetabi.cc')
          return `${origin}/dashboard`
        }

        try {
          const parsed = new URL(url)
          if (parsed.host === 'api.tabetabi.cc') {
            parsed.host = 'tabetabi.cc'
            parsed.pathname = parsed.pathname.replace(/^\/api\/auth/, '')
            return parsed.toString()
          }
          if (parsed.host === 'localhost:9999') {
            const origin = typeof window !== 'undefined' ? window.location.origin : 'http://localhost:4456'
            parsed.host = new URL(origin).host
            parsed.pathname = parsed.pathname.replace(/^\/api\/auth/, '')
            return parsed.toString()
          }
          return url
        } catch {
          if (url.startsWith('/') && !url.startsWith('//')) {
            const origin = typeof window !== 'undefined' ? window.location.origin : (import.meta.env.VITE_APP_URL || 'https://tabetabi.cc')
            return `${origin}${url}`
          }
          return url
        }
      }

      if (ctx.body && typeof ctx.body === 'object') {
        const body = ctx.body as Record<string, any>
        if ('callbackURL' in body && typeof body.callbackURL === 'string') {
          body.callbackURL = normalizeCallbackURL(body.callbackURL)
        }
      }

      if (ctx.query && typeof ctx.query === 'object') {
        const query = ctx.query as Record<string, any>
        if ('callbackURL' in query && typeof query.callbackURL === 'string') {
          query.callbackURL = normalizeCallbackURL(query.callbackURL)
        }
      }
    },
  },
})
